import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import compose from 'recompose/compose';
import { hideNotification as hideNotificationAction } from '../../actions/NotificationActions';
import { propFunc, propStr } from '../../helpers/custom-prop-types';
import NotificationMessage from './NotificationMessage';
const Notification = ({ hideNotification, message, notificationType }) => {
    const setClass = notificationType === 'normal' ? 'is-status-info' : 'is-status-alert';
    return (_jsxs(_Fragment, { children: [message && (_jsx(NotificationMessage, { className: setClass, hideNotification: hideNotification, message: message })), _jsx(ToastContainer, {})] }));
};
Notification.propTypes = {
    hideNotification: propFunc().isRequired,
    message: propStr().isRequired,
    notificationType: propStr().isRequired,
};
const mapStateToProps = ({ notification }) => ({
    message: notification.message || '',
    notificationType: notification.notificationType || '',
});
const mapDispatchToProps = (dispatch) => ({
    hideNotification: () => dispatch(hideNotificationAction()),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(Notification);
